import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { name: '首页', path: '/' },
  { name: '热门爆料', path: '/category/shishi-baoliao' },
  { name: '黑料专区', path: '/category/heiliao-baoguang' },
  { name: '明星翻车', path: '/category/mingxing-fanche' },
  { name: '网红塌房', path: '/category/wanghong-tafang' },
  { name: '企业内幕', path: '/category/qiye-neimu' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50 shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <nav className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap flex-shrink-0">
            <span className={`text-xl font-heading font-bold ${scrolled ? 'text-foreground-900' : 'text-white'}`}>
              51吃瓜
            </span>
            <span className={`text-xs px-2 py-0.5 rounded-full font-label ${scrolled ? 'bg-primary-500 text-white' : 'bg-white/20 text-white'}`}>
              每日大赛
            </span>
          </Link>

          <div className="hidden lg:flex items-center gap-1">
            {navLinks.map((link) => {
              const isActive = location.pathname === link.path || (link.path !== '/' && location.pathname.startsWith(link.path));
              return (
                <Link
                  key={link.path}
                  to={link.path}
                  className={`px-3 py-2 text-sm font-label rounded-lg transition-colors whitespace-nowrap ${
                    isActive
                      ? scrolled ? 'text-primary-500 bg-primary-50 font-medium' : 'text-white bg-white/20 font-medium'
                      : scrolled ? 'text-foreground-600 hover:text-foreground-900 hover:bg-background-100' : 'text-white/80 hover:text-white hover:bg-white/10'
                  }`}
                >
                  {link.name}
                </Link>
              );
            })}
          </div>

          <div className="hidden lg:flex items-center gap-3">
            <button className={`px-4 py-2 text-sm font-label rounded-full transition-all whitespace-nowrap ${
              scrolled
                ? 'border border-foreground-200 text-foreground-700 hover:bg-foreground-50'
                : 'border border-white/40 text-white hover:bg-white/10'
            }`}>
              <i className="ri-upload-2-line mr-1"></i>投稿入口
            </button>
            <button className={`p-2 rounded-full transition-colors ${
              scrolled ? 'text-foreground-600 hover:text-foreground-900 hover:bg-background-100' : 'text-white/80 hover:text-white hover:bg-white/10'
            }`}>
              <i className="ri-search-line text-lg"></i>
            </button>
            <Link
              to="/about"
              className={`px-5 py-2 text-sm font-label rounded-full transition-all whitespace-nowrap ${
                scrolled
                  ? 'bg-primary-500 text-white hover:bg-primary-600'
                  : 'bg-white text-foreground-900 hover:bg-white/90'
              }`}
            >
              关于我们
            </Link>
          </div>

          <button
            className="lg:hidden p-2 rounded-lg"
            onClick={() => setMobileOpen(!mobileOpen)}
          >
            <i className={`ri-${mobileOpen ? 'close' : 'menu'}-line text-2xl ${scrolled ? 'text-foreground-900' : 'text-white'}`}></i>
          </button>
        </div>

        {mobileOpen && (
          <div className="lg:hidden bg-background-50 border-t border-background-200 pb-4 px-2">
            <div className="flex flex-col gap-1 pt-2">
              {navLinks.map((link) => {
                const isActive = location.pathname === link.path || (link.path !== '/' && location.pathname.startsWith(link.path));
                return (
                  <Link
                    key={link.path}
                    to={link.path}
                    className={`px-4 py-3 text-sm font-label rounded-lg transition-colors ${
                      isActive
                        ? 'text-primary-500 bg-primary-50 font-medium'
                        : 'text-foreground-700 hover:bg-background-100'
                    }`}
                  >
                    {link.name}
                  </Link>
                );
              })}
              <hr className="my-2 border-background-200" />
              <button className="px-4 py-3 text-sm font-label text-foreground-700 hover:bg-background-100 rounded-lg text-left">
                <i className="ri-upload-2-line mr-2"></i>投稿入口
              </button>
              <Link to="/about" className="px-4 py-3 text-sm font-label text-foreground-700 hover:bg-background-100 rounded-lg">
                <i className="ri-information-line mr-2"></i>关于我们
              </Link>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
}